import { SoundEffect } from "@hg/media"

import SfxClick from "../assets/audio/sfx/click.mp3"
import SfxClip from "../assets/audio/sfx/clip.mp3"
import SfxCoinIn from "../assets/audio/sfx/coinIn.mp3"
import SfxCopperModal from "../assets/audio/sfx/copperModal.mp3"
import SfxFlagIn from "../assets/audio/sfx/flagIn.mp3"
import SfxGameIn from "../assets/audio/sfx/gameIn.mp3"
import SfxHandIn from "../assets/audio/sfx/handIn.mp3"
import SfxLobbyButtonHover from "../assets/audio/sfx/lobbyButtonHover.mp3"
import SfxRecordModal from "../assets/audio/sfx/recordModal.mp3"
import SfxResultIn from "../assets/audio/sfx/resultIn.mp3"
import SfxResultModal from "../assets/audio/sfx/resultModal.mp3"
import SfxStamp from "../assets/audio/sfx/stamp.mp3"

export const SFX = new SoundEffect({
    effectsDict: {
        click: SfxClick,
        copperModal: SfxCopperModal,
        recordModal: SfxRecordModal,
        lobbyButtonHover: SfxLobbyButtonHover,
        resultIn: SfxResultIn,
        gameIn: SfxGameIn,
        clip: SfxClip,
        stamp: SfxStamp,
        flagIn: SfxFlagIn,
        coinIn: SfxCoinIn,
        handIn: SfxHandIn,
        resultModal: SfxResultModal,
    },
    volume: 1,
})
